<script>
    import { auth, db, googleProvider } from '../../firebase/firebase.config';
    
	// Stores
    import {UserStore} from '../../store';

    let inputEmail;
    let inputPassword;

    // Handle Sign-in User through Email & Password.
    const handleSigninUser = (e) => {
        e.preventDefault();
        auth.signInWithEmailAndPassword(inputEmail, inputPassword)
        .then(cred => {
            let user = auth.currentUser;
        }).catch(err => {
            console.log('create user failed', err);
        });
    };
    
    // Handle Sign-in User through Google.
    const handleGoogleSignin = (e) => {
        auth.signInWithPopup(googleProvider)
        .then(result => {
            let token = result.credential.accessToken;
            let user = result.user;
        }).catch(err => {
            console.log('google signup err', err)
        });
    };
</script>

<form class="form-signin" on:submit|preventDefault={handleSigninUser}>
    <h1 class="h3 mb-3 font-weight-normal">Please sign in</h1>
    <label for="inputEmail" class="sr-only">Email address</label>
    <input type="email" id="inputEmail" class="form-control" placeholder="Email address" required="" bind:value={inputEmail}>
    <label for="inputPassword" class="sr-only">Password</label>
    <input type="password" id="inputPassword" class="form-control" placeholder="Password" required="" bind:value={inputPassword}>
    <div class="checkbox mb-3">
        <label class="text-white">
            <input type="checkbox" value="remember-me"> Remember me
        </label>
    </div>
    <button class="btn btn-lg btn-primary btn-block" type="submit">Sign in</button>
    
    <!-- Firebase Authenication Btns -->
    <button class="btn btn-link btn-lg w-100 text-center text-white mt-3" on:click={handleGoogleSignin}>Sign In with Google</button>
</form>